export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;

export const ADMIN_API_NAME = 'AdminQueries';

export enum ADMIN_API_PATH {
  getUser = '/getUser',
  listUsers = '/listUsers',
  confirmUserSignUp = '/confirmUserSignUp',
}
